import React from 'react';

import { VStack } from '@rbilabs/universal-components';

import { CmsQuestRequirement } from 'components/quests/cms-hooks/types';
import { IQuest } from 'components/quests/loyalty-quest/types';
import { ILoyaltyQuestsUiDetailFragment } from 'generated/sanity-graphql';

import { QuestStep } from '../quest-step';

interface IRegularStepsProps {
  quest: IQuest;
  // @TODO: Add proper type for cmsSteps
  cmsSteps: any;
  cmsQuestRequirementById: CmsQuestRequirement;
  cmsQuestDetailUI: ILoyaltyQuestsUiDetailFragment;
  onCloseDrawer: () => void;
}

export const RegularSteps = ({
  quest,
  cmsSteps,
  cmsQuestRequirementById,
  cmsQuestDetailUI,
  onCloseDrawer,
}: IRegularStepsProps) => {
  return (
    <VStack space="$4">
      {(quest?.steps || []).map((step, index) => (
        <QuestStep
          key={step.id}
          step={step}
          quest={quest}
          cmsStep={cmsSteps[index]}
          cmsQuestRequirementById={cmsQuestRequirementById}
          cmsQuestDetailUI={cmsQuestDetailUI}
          onCloseDrawer={onCloseDrawer}
        />
      ))}
    </VStack>
  );
};
